import * as actionTypes from "../actionTypes";

const initialState = {
  nextFormNr: null,
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_NEXT_FORM_NR_SUCCEED:
      return {
        ...state,
        nextFormNr: action.payload,
      };
    default:
      return state;
  }
}

export default reducer;
